import { Vector3 } from '@babylonjs/core';
import { EnemyDistributionConfig } from '../EnemyGenerator';
import { ENEMY_ANIMATIONS, EnemyBehavior } from './EnemyBehavior';

/**
 * Circle behavior - walk in a circle around spawn point
 */

export class EnemyCircleBehavior extends EnemyBehavior {
  private angle: number = 0;

  constructor(startPosition: Vector3, config: EnemyDistributionConfig) {
    config.sound = {
      name: 'enemywalk',
      autoplay: true,
    };
    super('enemyCircle', startPosition, config);
  }

  behaviorUpdate(deltaTime: number): void {
    // Play walk animation
    this.playAnimation(ENEMY_ANIMATIONS.WALK, true);

    // Update angle based on speed
    const angularSpeed = this.config.speed / this.config.circleRadius;
    this.angle += angularSpeed * deltaTime;

    // Calculate position on circle
    const x = this.startPosition.x + Math.cos(this.angle) * this.config.circleRadius;
    const z = this.startPosition.z + Math.sin(this.angle) * this.config.circleRadius;

    this.mesh.position.x = x;
    this.mesh.position.z = z;
    // this.mesh.position.y = this.startPosition.y; // Removed for snap
    this.snapToGround(deltaTime);

    // Face tangent direction
    this.mesh.rotation.y = -this.angle;
  }

  clone(): EnemyCircleBehavior {
    return new EnemyCircleBehavior(this.startPosition, this.config);
  }
}
